import { CommonModule } from '@angular/common';
import { MonitoringAreaComponent } from './monitoring-area.component';
import { NgModule } from '@angular/core';
import { AreaMenuModule } from '@caslink/common-client/ng-app/area-menu/area-menu.module';
import { HardwareItemSyncLoadingAnimationModule } from '@caslink/device-client/ng-app/hardware-item-sync-loading-animation/hardware-item-sync-loading-animation.module';
import { SubToolbarModule } from '@caslink/common-client/ng-app/sub-toolbar/sub-toolbar.module';

@NgModule({
    imports: [
        AreaMenuModule,
        CommonModule,
        HardwareItemSyncLoadingAnimationModule,
        SubToolbarModule,
    ],
    declarations: [
        MonitoringAreaComponent,
    ],
    exports: [
        MonitoringAreaComponent,
    ],
})
export class MonitoringAreaModule {}
